import React from 'react';
export function FinalCTA() {
  return <section className="py-10 bg-slate-900 text-white" data-id="element-41">
      <div className="max-w-md mx-auto px-4 text-center" data-id="element-42">
        <p className="text-2xl md:text-3xl font-bold italic mb-6 text-white/90" data-id="element-43">
          Hacé clic y empezá hoy.
        </p>
        <a href="#comprar" className="inline-flex items-center gap-3 bg-white text-slate-900 font-black text-lg tracking-wide uppercase px-10 py-4 rounded-full hover:bg-slate-100 transition-colors shadow-xl" data-id="element-44">
          Acceder ahora
          <span className="text-xl" data-id="element-45">→</span>
        </a>
      </div>
    </section>;
}